import { useState, useEffect } from 'react';
import { useButtonsStore } from '../../../store/models';

function useEcalWorldSwitch (props) {
    const { row } = props;
    const buttonsStore = useButtonsStore();

    const [publisherButton, setPublisherButton] = useState(buttonsStore.publisherButton);
    const [confirmOpen, setConfirmOpen] = useState(false);

    useEffect(() => {
        setPublisherButton(buttonsStore.publisherButton);
    }, [buttonsStore.publisherButton]);

    const isPublic = publisherButton?.id === row.id
        && publisherButton?.publicButton === true;

    const tooltipTitle = isPublic
        ? 'Discoverable in ECAL World — click to disable'
        : 'Make discoverable in ECAL World';

    const dialogTitle = isPublic ? 'Disable ECAL World' : 'Enable ECAL World';

    const dialogText = isPublic
        ? 'Are you sure you want to turn off this button for ECAL World?'
        : 'Are you sure you want to make this button discoverable in ECAL World?';

    function handleToggle (e) {
        e.stopPropagation();
        e.preventDefault();
        setConfirmOpen(true);
    }

    function handleConfirm () {
        buttonsStore.setPublisherButton({
            buttonWidgetId: row.id,
            publicButton: !isPublic,
        });
        setConfirmOpen(false);
    }

    function handleCancel () {
        setConfirmOpen(false);
    }

    return {
        isPublic,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        handleToggle,
        handleConfirm,
        handleCancel,
    };
}

export default useEcalWorldSwitch;
